import {
  REQUESTED_VALIDATE,
  REQUESTED_VALIDATE_SUCCEEDED,
  REQUESTED_VALIDATE_FAILED,
} from "../actions/types"

export const INITIAL_STATE = {
  data: {},
  requests: [],
  loading: false,
  error: false,
}

export default function validateReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUESTED_VALIDATE:
      return {
        ...state,
        requests: state.requests.concat([action]),
        loading: true,
        error: false,
      }
    case REQUESTED_VALIDATE_SUCCEEDED:
      return {
        ...state,
        data: action.response.data,
        loading: false,
        error: false,
      }
    case REQUESTED_VALIDATE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      }
    default:
      return state
  }
}
